<template>
  <nav class="menu">
    <template v-if="!isLogin">
      <div class="login logmenu" v-for="(routes, index) in menuLogIn" v-bind:key="index">
        <div class="img_box">
          <img v-bind:src="routes.src" />
        </div>
        <router-link to="#" v-b-modal.login_modal v-if="routes.text == '登入'">{{ routes.text }}</router-link>
      </div>
    </template>
    <template v-else>
      <div class="logout logmenu" v-for="(routes, index) in menuLogOut" v-bind:key="index">
        <div class="img_box">
          <img :src="require('@/assets/images/icon/man_menu_hover.svg')" />
        </div>
        <p>{{ name }}</p>
        <router-link
          :to="{ name: 'home' }"
          @click.native="logout()"
          v-if="routes.text == '登出'"
        >{{ routes.text }}</router-link>
      </div>
    </template>
    <div class="other_link">
      <router-link
        v-for="(routes, index) in menuOtherLinks"
        v-bind:key="index"
        :to="routes.to"
      >{{ routes.text }}</router-link>
    </div>
    <div class="list_link">
      <router-link
        class="hoverTextBgc"
        v-for="(classification, index) in classifications"
        v-bind:key="index"
        :to="{ name: 'products.index', params: { id: classification.TypeID } }"
      >{{ classification.TypeName }}</router-link>
    </div>
    <b-nav-form class="mobile-search">
      <b-form-input
        v-model="keyword"
        @keyup.enter.native="seach"
        size="sm"
        type="text"
        placeholder="搜尋..."
        autocomplete="off"
      />
      <b-button size="sm" class="login_search" type="button" @click="seach"></b-button>
    </b-nav-form>
  </nav>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex"; //自動抓getter我寫的
import man_menu from "@/assets/images/icon/man_menu_hover.svg";
import searchMixin from "@/mixins/search";
// import $ from "jquery";

export default {
  mixins: [searchMixin],
  computed: {
    ...mapGetters("user", [
      //...打散ob,array
      "isLogin",
      "name",
      "avatar"
    ]),
    ...mapGetters("classifications", ["classifications"])
  },
  data() {
    return {
      menuLogIn: [
        {
          text: "登入",
          src: man_menu
        }
      ],
      menuLogOut: [
        {
          username: "王曉明",
          text: "登出",
          src: man_menu
        }
      ],
      menuOtherLinks: [
        {
          text: "訂單查詢",
          to: {
            name: "orders"
          }
        },
        {
          text: "收藏課程",
          to: {
            name: "collection"
          }
        }
      ]
    };
  },

  created() {
    this.loadClassifications();
  },

  methods: {
    ...mapActions("classifications", ["loadClassifications"]),
    ...mapMutations("user", ["setUser"]),
    logout() {
      this.setUser({});
    }
  }
};
</script>